import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Radio, message, Modal, Result, Button } from "antd";
import pickImage from "../../images/pick.png";
import noSchelesImage from "../../images/noschedule.png";
import {
  epochToNormalDate,
  displayScheduleDateFullNameFormat,
} from "../../utils/utility";
import schedulesActions from "../../redux/schedules/actions";
import { t } from "i18next";

const ChooseTwoWayBackHour = () => {
  const dispatch = useDispatch();
  const { cities } = useSelector((state) => state.citiesReducer);

  const [messageApi, contextHolder] = message.useMessage();
  const { setSchedulesTwoWayId, setOpenChooseTwoWayScheduleModal } =
    schedulesActions;
  const { selectedLanguage } = useSelector((state) => state.mainReducer);
  const {
    schedules,
    schedulesTwoWay,
    schedulesTwoWayId,
    openChooseTwoWayScheduleModaL,
    schedulesId,
  } = useSelector((state) => state.schedulesReducer);

  const getExactSchedule = schedules?.find(
    (schedule) => schedule?.kursId === schedulesId
  );

  const getExactScheduleTwoWay = schedulesTwoWay?.find(
    (schedule) => schedule?.kursId === schedulesTwoWayId
  );

  const findCityName = (scheduleId) => {
    return selectedLanguage === "bg"
      ? cities?.find((city) => city?.id === scheduleId)?.name
      : cities?.find((city) => city?.id === scheduleId)?.nameLat;
  };

  const filteredSchedulesTwoWay = schedulesTwoWay.filter(
    (schedule) =>
      schedule.kursId !== getExactSchedule?.kursId &&
      schedule.scheduleStart > getExactSchedule?.scheduleStart
  );

  const displayScheduleTime = (schedule) => {
    return epochToNormalDate(schedule)?.replace(/\d{2}\/\d{2}\/\d{2}/, "");
  };

  const warning = () => {
    messageApi.open({
      type: "warning",
      content: t("pleaseSelectReturnTime"),
    });
  };

  const closeModal = () => {
    if (schedulesTwoWayId > 0) {
      dispatch(setOpenChooseTwoWayScheduleModal(false));
    } else {
      warning();
    }
  };

  const radioGroupstyle = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  return (
    <>
      {contextHolder}
      <Modal
        closable={false}
        centered
        footer={null}
        open={openChooseTwoWayScheduleModaL}
      >
        {filteredSchedulesTwoWay.length === 0 ? (
          <Result
            icon={<img src={noSchelesImage} alt="noschedule" width="80px" />}
            title={
              <div>
                <p>{t("noScheduleFound")}</p>
                <p>{t("forReturnTime")}</p>
              </div>
            }
            subTitle={t("pleaseSelectOtherDateTwoWay")}
            extra={
              <Link to="/">
                <Button
                  className="custom-button"
                  size="large"
                  style={{ width: "100%" }}
                  type="primary"
                  key="console"
                >
                  {t("home")}
                </Button>
              </Link>
            }
          />
        ) : (
          <div>
            <Result
              style={{ padding: "10px 10px" }}
              icon={<img src={pickImage} width="100px" alt="pick" />}
              title={
                <p style={{ fontSize: "21px" }}>
                  {t("pleaseSelectReturnTime")}
                </p>
              }
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <h3>
                {findCityName(getExactSchedule.toCity)} -{" "}
                {findCityName(getExactSchedule.fromCity)}
              </h3>
              <p style={{ fontSize: "16px" }}>
                {getExactScheduleTwoWay && (
                  <div>
                    {displayScheduleDateFullNameFormat(
                      getExactScheduleTwoWay?.scheduleStart
                    )}{" "}
                    {displayScheduleTime(getExactScheduleTwoWay?.scheduleStart)}
                  </div>
                )}
              </p>

              <Radio.Group
                onChange={(e) => dispatch(setSchedulesTwoWayId(e.target.value))}
                size="large"
                style={radioGroupstyle}
                value={schedulesTwoWayId}
              >
                {filteredSchedulesTwoWay.map((schedule) => (
                  <Radio value={schedule.kursId} key={schedule.kursId}>
                    <h2 style={{ fontWeight: "400" }}>
                      {t("departure")}{" "}
                      {displayScheduleTime(schedule?.scheduleStart)} ч.
                    </h2>
                  </Radio>
                ))}
              </Radio.Group>
              <Button
                size="large"
                className="custom-button"
                type="primary"
                style={{ width: "100%" }}
                onClick={closeModal}
              >
                {t("select")}
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ChooseTwoWayBackHour;
